import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { LatLng } = protos;

export function selectMetroArea(metroArea: core.MetroArea): BaseTockAction<core.MetroArea> {
  return {
    type: AppConstants.METRO_AREA_SELECTED,
    payload: metroArea,
  };
}

/**
 * Fetches closest metro area from a LatLng
 *
 * @returns {Object} A redux TockApi action.
 */

export function findClosestMetroArea(location: core.LatLng): ApiAction {
  return {
    TockApi: {
      postProto: '/metroarea/closest',
      type: AppConstants.METRO_AREA_CLOSEST,
      request: LatLng.fromObject(location),
    },
  };
}
